import { getReviewSubmissionClientData } from '../helper/get-review-submission-client-data';
import { emitFormErrorActionTracking } from '../tracking/submit-action';
import { showSuccessView } from './show-success-view';
import { submitReview } from './submission/submit-review';
import { trackServerAction } from './track-server-action';
import { checkAndHandleValidity } from './validity-check/check-and-handle-validity';
import { FormWidget } from '../form-widget';
import { setSubmitButtonState } from '../helper/set-submit-button-state';
import { push as showSnackbar } from '@otto-ec/otto-components/snackbar/v1';

export type SubmitButtonClickHandlerParams = {
    rootElement: Pick<HTMLElement, 'querySelector' | 'querySelectorAll' | 'dataset'>;
    formWidgets: FormWidget[];
};

const HTTP_STATUS_PRECONDITION_FAILED = 412;

export const SubmitButtonClickHandler =
    ({ rootElement, formWidgets }: SubmitButtonClickHandlerParams) =>
    async () => {
        const clientData = getReviewSubmissionClientData({ rootElement });
        if (clientData.status !== 'CAN_SUBMIT') throw new Error('Review submission data is not submittable');

        const check = await checkAndHandleValidity({ rootElement, formWidgets });
        if (!check.valid) {
            emitFormErrorActionTracking({
                errorReason: check.reason,
                variationId: clientData.variation.id,
                source: clientData.reviewSource,
            });
            return;
        }

        try {
            setSubmitButtonState({ rootElement, disabled: true, loading: true });
            await submitReview({ rootElement });
            await showSuccessView({ rootElement });

            await trackServerAction({ rootElement, success: true });
        } catch (error) {
            await trackServerAction({ rootElement, success: false });
            if (error instanceof Error) {
                if (isAlreadyReviewedByCustomer(error)) {
                    await showSuccessView({ rootElement });
                    return;
                }
            }
            showSnackbar(
                'Das hat leider nicht geklappt. Bitte versuche es noch einmal oder speichere deine Eingaben und versuche es später erneut.'
            );
            setSubmitButtonState({ rootElement, disabled: false, loading: false });
        }
    };

function isAlreadyReviewedByCustomer(error: Error) {
    return error.message.includes(`[${HTTP_STATUS_PRECONDITION_FAILED}]`);
}
